import {
	AppBar,
	Dialog,
	IconButton,
	Radio,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import grey from '@material-ui/core/colors/grey';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TextField from '@material-ui/core/TextField';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {
	IApply,
	IApprovalItem,
	IApprovalStayMealData,
	openApprovalConfirm,
	openApprovals,
	setApprovals,
	setApprovalsSelectedColumns,
	setApprovalsSelectedColumnsForStayMeal,
	setCanApproval,
} from '../actions/search';
import { IRootState } from '../reducers';
import i18next from '../resources/i18n';
import ScenarioFactory, {
	IApplyCareersParam,
} from '../scenario/SearchScenarioFactory';
import MessageDialog from './MessageDialog';
import ReactTable, { RowRenderProps } from './MyReactTable';

import CloseIcon from '@material-ui/icons/Close';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { IMessage } from 'src/actions/message';
import CareerDetail from 'src/containers/CareerDetail';
import { UpwardTransition } from 'src/utils';
import { Routes, Screens } from 'src/utils/Routes';
import { isMobile } from '../utils/MobileCheck';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		button: {
			margin: '10px',
		},
		careerDialog: {
			width: '80%',
		},
		checkbox: {
			height: 36,
			width: 36,
		},
		column: {
			display: 'inline-block',
			textAlign: 'center',
			width: '33.33%',
		},
		flex: {
			flex: 1,
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileColumn: {
			display: 'inline-block',
			textAlign: 'center',
			width: '100%',
		},
		mobileWrapDiv: {
			margin: '2px',
		},
		pointer: {
			cursor: 'pointer',
		},
		root: {
			flexGrow: 1,
			margin: '10px',
			padding: 24,
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
		textArea: {
			width: '100%',
		},
		whiteSpace: {
			whiteSpace: 'normal',
		},
		whiteSpaceMenuItem: {
			whiteSpace: 'normal',
			'word-break': 'break-all',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteState
	extends Pick<
		IState,
		| 'approverId1'
		| 'approverId2'
		| 'approverId4'
		| 'reason'
		| 'careerID'
		| 'careerTypeID'
		| 'classId'
	> {
	caller: Parameters<IProps['pushHistory']>[0];
	preClassID: IState['classId'];
}

interface IState {
	errorDialogOpen: boolean;
	errorDialogContent: string;
	errorDialogReplacements: string[];
	selectColumnsMenuAnchorEl?: HTMLElement;
	reason: string;
	fetchedCanApprovalMessage: boolean;
	openCareerDetailDialog: boolean;
	careerID: string;
	careerTypeID: string;
	classId: string;
	approverId1: string | null;
	approverId2: string | null;
	approverId4: string | null;
}

/**
 * クラス選択画面
 */
class ApprovalsChange extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			approverId1: this.props.location.state.approverId1,
			approverId2: this.props.location.state.approverId2,
			approverId4: this.props.location.state.approverId4,
			careerID: '',
			careerTypeID: this.props.location.state.careerTypeID,
			classId: '',
			errorDialogContent: '',
			errorDialogOpen: false,
			errorDialogReplacements: [],
			fetchedCanApprovalMessage: false,
			openCareerDetailDialog: false,
			reason: '',
		};
		this.openConfirmDialog = this.openConfirmDialog.bind(this);
		this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
		this.closeErrorDialog = this.closeErrorDialog.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.onClickCancel = this.onClickCancel.bind(this);
		this.onChangeApprover = this.onChangeApprover.bind(this);
		this.onChangeReason = this.onChangeReason.bind(this);
		this.applyCareers = this.applyCareers.bind(this);
		this.okCanApproval = this.okCanApproval.bind(this);
		this.closeCanApproval = this.closeCanApproval.bind(this);
		this.getParams = this.getParams.bind(this);
		this.getApproverId1 = this.getApproverId1.bind(this);
		this.getApproverId2 = this.getApproverId2.bind(this);
		this.getApproverId4 = this.getApproverId4.bind(this);
		this.getCancel = this.getCancel.bind(this);
		this.getPeriod = this.getPeriod.bind(this);
	}

	public componentDidMount() {
		if (this.props.location.state.reason) {
			this.setState({
				reason: this.props.location.state.reason,
			});
		}
	}

	public render() {
		const { classes } = this.props;
		const data = this.props.data.filter(
			item => item.classId !== this.props.location.state.classId
		);
		const columns = this.getSelectedColumns();
		const mobileColumns = this.getSelectedMobileColumns();

		const dialogOpen: boolean =
			this.props.isOpenApprovalConfirm ||
			this.state.errorDialogOpen ||
			this.props.isOpenCanApproval;
		let showCancel: boolean = false;
		let dialogTitle: string = '';
		let dialogContent: IMessage[] = [];
		let onDialogClose: () => void;
		let onDialogOk: () => void;

		// 登録確認ダイアログで初期化
		showCancel = true;
		dialogTitle = i18next.t('ApprovalsChange_0001');
		dialogContent = [{ content: 'LMCM_E_15020' }];
		onDialogClose = this.closeConfirmDialog;
		onDialogOk = this.applyCareers;

		if (this.state.errorDialogOpen) {
			// 入力エラー時
			showCancel = false;
			dialogTitle = i18next.t('ApprovalsChange_0002');
			dialogContent = [
				{
					content: this.state.errorDialogContent,
					replacements: this.state.errorDialogReplacements,
				},
			];
			onDialogClose = this.closeErrorDialog;
			onDialogOk = this.closeErrorDialog;
		}

		const selected = this.props.data.filter(
			item => item.classId === this.state.classId
		).length;
		const indicator = selected
			? `${selected}${i18next.t('ApprovalsChange_0003')}`
			: '';
		return (
			<Paper className={classes.root}>
				{!isMobile() && (
					<>
						<div className={classes.wrapDiv}>
							<ReactTable
								data={data}
								columns={columns}
								defaultPageSize={10}
								className="-striped -highlight"
								columnsMenu={true}
								menuHandler={this.handleSelectColumns}
								indicator={indicator}
							/>
						</div>
						{this.getSelectColumnsMenu()}
					</>
				)}

				{isMobile() && (
					<>
						<div className={classes.mobileWrapDiv}>
							<ReactTable
								data={data}
								columns={mobileColumns}
								defaultPageSize={10}
								className="-striped -highlight"
								indicator={indicator}
							/>
						</div>
					</>
				)}
				{!isMobile() && (
					<>
						<div className={classes.column} />
						<div className={classes.column}>
							<TextField
								id="multiline-flexible"
								className={classes.textArea}
								label={i18next.t('ApprovalsChange_0004')}
								multiline={true}
								rows="4"
								margin="normal"
								value={this.state.reason}
								onChange={this.onChangeReason}
							/>
						</div>
						<div className={classes.column} />
					</>
				)}
				{isMobile() && (
					<>
						<div className={classes.mobileColumn}>
							<TextField
								id="multiline-flexible"
								className={classes.textArea}
								label={i18next.t('ApprovalsChange_0004')}
								multiline={true}
								rows="4"
								margin="normal"
								value={this.state.reason}
								onChange={this.onChangeReason}
							/>
						</div>
					</>
				)}

				<>
					<div className={classes.mobileColumn}>
						<Button
							variant="contained"
							color="primary"
							onClick={this.openConfirmDialog}
						>
							{i18next.t('ApprovalsChange_0005')}
						</Button>
						&nbsp;&nbsp;&nbsp;
						<Button
							variant="contained"
							color="primary"
							onClick={this.goback}
						>
							{i18next.t('ApprovalsChange_0006')}
						</Button>
					</div>
				</>
				<MessageDialog
					open={dialogOpen}
					showCancelButton={showCancel}
					title={dialogTitle}
					contents={dialogContent}
					onClose={onDialogClose}
					onClickOk={onDialogOk}
				/>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openCareerDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18next.t('ApprovalsChange_0007')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerDetail careerID={this.state.careerID} />
				</Dialog>
			</Paper>
		);
	}

	protected goback = (event: React.MouseEvent<HTMLElement>) => {
		const newApprovals = JSON.parse(JSON.stringify(this.props.data));
		const approverId1 = this.props.location.state.approverId1;
		const approverId2 = this.props.location.state.approverId2;
		const approverId4 = this.props.location.state.approverId4;
		if (this.props.location.state.preClassID) {
			// tslint:disable-next-line: prefer-for-of
			for (let index = 0; index < newApprovals.length; index++) {
				if (
					newApprovals[index]['classId'] ===
					this.props.location.state.preClassID
				) {
					newApprovals[index]['approverId1'] = approverId1;
					newApprovals[index]['approverId2'] = approverId2;
					newApprovals[index]['approverId4'] = approverId4;
					this.props.setApprovals(newApprovals);
				}
			}
			const params = {
				caller: this.props.location.state.caller,
				careerId: this.state.careerID,
				classId: this.props.location.state.preClassID,
				reason: this.props.location.state.reason,
			};
			const to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE)
				.replace(
					/\/:career_id/,
					`/${this.props.location.state.careerID}`
				)
				.replace(
					/\/:class_id/,
					`/${this.props.location.state.classId}`
				);
			this.props.pushHistoryState(to, params);
		} else {
			// tslint:disable-next-line: prefer-for-of
			for (let index = 0; index < newApprovals.length; index++) {
				if (
					newApprovals[index]['classId'] ===
					this.props.location.state.classId
				) {
					if (this.state.approverId1 !== null) {
						newApprovals[index]['approverId1'] = approverId1;
					}
					if (this.state.approverId2 !== null) {
						newApprovals[index]['approverId2'] = approverId2;
					}
					if (this.state.approverId4 !== null) {
						newApprovals[index]['approverId4'] = approverId4;
					}
					this.props.setApprovals(newApprovals);
				}
			}
			const params = {
				caller: this.props.location.state.caller,
				careerId: this.state.careerID,
				classId: this.props.location.state.classId,
				reason: this.props.location.state.reason,
			};
			let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
			to = to.replace(
				/\/:career_id/,
				`/${this.props.location.state.careerID}`
			);
			to = to.replace(
				/\/:class_id/,
				`/${this.props.location.state.classId}`
			);
			this.props.pushHistoryState(to, params);
		}
	};

	protected handleShowDetailDialog = (
		event: React.MouseEvent<HTMLElement>
	) => {
		const careerId = event.currentTarget.getAttribute('data-careerid');
		const careerType = event.currentTarget.getAttribute('data-careertype');
		if (careerId && careerId !== '' && careerType && careerType !== '') {
			if (careerType === '0') {
				this.setState({
					careerID: careerId,
					openCareerDetailDialog: true,
				});
			}
		}
	};

	protected handlecloseDetailDialog = () => {
		this.setState({
			careerID: '',
			openCareerDetailDialog: false,
		});
	};

	/**
	 * 申請前ダイアログOKボタン
	 */
	protected okCanApproval() {
		// ダイアログを閉じて確認ダイアログを表示
		this.props.closeCanApproval();
		this.props.openApprovalConfirm(true);
	}

	/**
	 * 申請前ダイアログクローズ
	 */
	protected closeCanApproval() {
		// 検索終了
		this.setState({
			fetchedCanApprovalMessage: false,
		});
		// ダイアログを閉じる
		this.props.closeCanApproval();
	}

	/**
	 * 確認ダイアログオープン
	 */
	protected openConfirmDialog() {
		const { reason } = this.state;

		const selectable = this.props.data.filter(
			item => item.classId === this.state.classId
		);

		if (selectable.length === 0) {
			this.setState({
				errorDialogContent: 'LMCM_E_15021',
				errorDialogOpen: true,
				errorDialogReplacements: [],
			});
			return;
		}
		// 入力チェック
		if (reason && reason.length > 200) {
			this.setState({
				errorDialogContent: 'CHK_E_0004',
				errorDialogOpen: true,
				errorDialogReplacements: [
					i18next.t('ApprovalsChange_0004'),
					'200',
				],
			});
			return;
		}

		let cancelWaitCount = 0;
		this.props.data.map((approval: IApprovalItem) => {
			if (null !== approval.cancel && approval.classId !== 'CL000000') {
				cancelWaitCount++;
			}
		});
		if (cancelWaitCount === 0) {
			// キャンセル待ちが無ければ確認ダイアログを表示
			this.props.openApprovalConfirm(true);
		} else if (cancelWaitCount === 1) {
			// 検索中とする
			this.setState({
				fetchedCanApprovalMessage: true,
			});
			// キャンセル待ちが1件であれば、サーバよりメッセージ取得
			const params = this.getParams();
			this.props.fetchCanApproval(this.props.token, params);
		} else {
			// キャンセル待ちが複数であればエラーメッセージ
			this.setState({
				errorDialogContent: 'LMCM_E_00611',
				errorDialogOpen: true,
				errorDialogReplacements: [],
			});
		}
	}

	/**
	 * 確認ダイアログクローズ
	 */
	protected closeConfirmDialog() {
		this.props.openApprovalConfirm(false);
	}

	/**
	 * 確認ダイアログクローズ
	 */
	protected closeErrorDialog() {
		this.setState({ errorDialogOpen: false });
	}

	protected check = (event: React.MouseEvent<HTMLElement>) => {
		const classId = event.currentTarget.getAttribute('data-classId');
		if (classId && classId !== '') {
			if (this.state.classId === classId) {
				this.setState({
					classId: '',
				});
			} else {
				this.setState({
					classId,
				});
			}
		}
	};

	/**
	 * カラム表示制御
	 */
	protected getAllColumns() {
		const { classes } = this.props;
		return [
			{
				Cell: (row: RowRenderProps) => {
					return (
						<div>
							{row.original.check !== null && (
								<Radio
									className={this.props.classes.checkbox}
									data-classId={row.original.classId}
									checked={
										this.state.classId ===
										row.original.classId
									}
									onClick={this.check}
								/>
							)}
						</div>
					);
				},
				accessor: 'check',
				required: true,
				sortable: false,
				width: 50,
			},
			{
				Header: i18next.t('ApprovalsChange_0008'),
				accessor: 'managementCode',
				minWidth: 100,
			},
			{
				Cell: (row: RowRenderProps) => {
					return (
						<span
							className={this.props.classes.link}
							data-careerid={row.original.careerId}
							data-careertype={row.original.careerType}
							onClick={this.handleShowDetailDialog}
						>
							{row.original.careerTitle}
						</span>
					);
				},
				Header: i18next.t('ApprovalsChange_0009'),
				accessor: 'careerTitle',
				minWidth: 120,
			},
			{
				Cell: (row: RowRenderProps) =>
					row.original.classId === 'CL000000'
						? i18next.t(row.value, { ns: 'force' })
						: row.value,
				Header: i18next.t('ApprovalsChange_0010'),
				accessor: 'className',
				minWidth: 120,
			},
			{
				Cell: (row: RowRenderProps) =>
					i18next.t(row.value, { ns: 'force' }),
				Header: i18next.t('ApprovalsChange_0011'),
				accessor: 'type',
				minWidth: 60,
			},
			{
				Cell: (row: RowRenderProps) => {
					const careerType = row.original.careerType;
					const careerTypeId = row.original.careerTypeId;
					const classId = row.original.classId;
					const endDateByYear = row.original.endDateByYear;
					const endDateByDay = row.original.endDateByDay;
					let period = row.value;
					if (period && period.indexOf('～') !== -1) {
						period = period.replace(
							'～',
							i18next.t('～', {
								ns: 'force',
							})
						);
					}
					if (
						careerType === 0 &&
						careerTypeId === 1 &&
						classId === 'CL000000' &&
						endDateByYear !== null
					) {
						return i18next.t('ApprovalsChange_0023', {
							endDateByYear,
						});
					} else if (
						careerType === 0 &&
						careerTypeId === 1 &&
						classId === 'CL000000' &&
						endDateByDay !== null
					) {
						return i18next.t('ApprovalsChange_0024', {
							endDateByDay,
						});
					} else {
						return period;
					}
				},
				Header: i18next.t('ApprovalsChange_0012'),
				accessor: 'period',
				minWidth: 100,
			},
			{
				Header: i18next.t('ApprovalsChange_0013'),
				accessor: 'target',
				minWidth: 80,
			},
			{
				Header: i18next.t('ApprovalsChange_0014'),
				accessor: 'organizer',
				minWidth: 80,
			},
			{
				Header: i18next.t('ApprovalsChange_0015'),
				accessor: 'place',
				minWidth: 70,
			},
			{
				Header: i18next.t('ApprovalsChange_0016'),
				accessor: 'cost',
				minWidth: 80,
			},
			{
				Header: i18next.t('ApprovalsChange_0017'),
				accessor: 'status',
				minWidth: 80,
				sortable: false,
			},
			{
				Cell: (row: RowRenderProps) => {
					if (row.original.cancel === null) {
						return '---';
					}
					return (
						<Checkbox
							className={classes.checkbox}
							id="cancel"
							color="primary"
							data-index={row.index}
							onClick={this.onClickCancel}
							checked={!!row.original.cancel}
						/>
					);
				},
				Header: i18next.t('ApprovalsChange_0018'),
				accessor: 'cancel',
				minWidth: 100,
				sortable: false,
			},
			{
				Cell: (row: RowRenderProps) => {
					if (row.original.needApprove1 !== 1) {
						return i18next.t('ApprovalsChange_0019');
					}
					const value =
						row.original.approverId1 == null
							? ''
							: row.original.approverId1;
					return (
						<Select
							id="approverId1"
							input={<Input name="approverId1" />}
							autoWidth={true}
							onChange={this.onChangeApprover}
							value={
								this.state.approverId1 == null
									? value
									: this.state.approverId1
							}
							displayEmpty={true}
						>
							{row.original.approverList1.map(
								(approver: any, i: number): JSX.Element => (
									<MenuItem
										key={i}
										value={approver.id}
										data-classId={row.original.classId}
									>
										{i18next.t(approver.name, {
											ns: 'force',
										})}
									</MenuItem>
								)
							)}
						</Select>
					);
				},
				Header: i18next.t('ApprovalsChange_0020'),
				accessor: 'approverId1',
				minWidth: 100,
				sortable: false,
			},
			{
				Cell: (row: RowRenderProps) => {
					if (row.original.needApprove2 !== 1) {
						return i18next.t('ApprovalsChange_0019');
					}
					const value =
						row.original.approverId2 == null
							? ''
							: row.original.approverId2;
					return (
						<Select
							id="approverId2"
							input={<Input name="approverId2" />}
							autoWidth={true}
							onChange={this.onChangeApprover}
							value={
								this.state.approverId1 == null
									? value
									: this.state.approverId2
							}
							displayEmpty={true}
						>
							{row.original.approverList2.map(
								(approver: any, i: number): JSX.Element => (
									<MenuItem
										key={i}
										value={approver.id}
										data-classId={row.original.classId}
									>
										{i18next.t(approver.name, {
											ns: 'force',
										})}
									</MenuItem>
								)
							)}
						</Select>
					);
				},
				Header: i18next.t('ApprovalsChange_0021'),
				accessor: 'approverId2',
				minWidth: 100,
				sortable: false,
			},
			{
				Cell: (row: RowRenderProps) => {
					if (row.original.needApprove4 !== 1) {
						return i18next.t('ApprovalsChange_0019');
					}
					const value =
						row.original.approverId4 == null
							? ''
							: row.original.approverId4;
					return (
						<Select
							id="approverId4"
							input={<Input name="approverId4" />}
							autoWidth={true}
							onChange={this.onChangeApprover}
							value={
								this.state.approverId1 == null
									? value
									: this.state.approverId4
							}
							displayEmpty={true}
						>
							{row.original.approverList4.map(
								(approver: any, i: number): JSX.Element => (
									<MenuItem
										key={i}
										value={approver.id}
										data-classId={row.original.classId}
									>
										{i18next.t(approver.name, {
											ns: 'force',
										})}
									</MenuItem>
								)
							)}
						</Select>
					);
				},
				Header: i18next.t('ApprovalsChange_0022'),
				accessor: 'approverId4',
				minWidth: 100,
				sortable: false,
			},
		];
	}

	protected getAllMobileColumns() {
		const { classes } = this.props;
		return [
			{
				Cell: (row: RowRenderProps) => {
					return (
						<>
							<Paper>
								<div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0026')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.check !== null && (
											<Radio
												className={
													this.props.classes.checkbox
												}
												data-classId={
													row.original.classId
												}
												checked={
													this.state.classId ===
													row.original.classId
												}
												onClick={this.check}
											/>
										)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0008')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.managementCode}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0009')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										<span
											className={this.props.classes.link}
											data-careerid={
												row.original.careerId
											}
											data-careertype={
												row.original.careerType
											}
											onClick={
												this.handleShowDetailDialog
											}
										>
											{row.original.careerTitle}
										</span>
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0010')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.classId === 'CL000000'
											? i18next.t(
													row.original.className,
													{
														ns: 'force',
													}
											  )
											: row.original.className}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0011')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{i18next.t(row.original.type, {
											ns: 'force',
										})}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0012')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getPeriod(row)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0013')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.target}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0014')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.organizer}
									</div>
									{this.props.location.state.careerTypeID ===
										'2' && (
										<React.Fragment>
											<div
												className={
													classes.mobileCellItemName
												}
											>
												{i18next.t(
													'ApprovalsChange_0015'
												)}
											</div>
											<div
												className={
													classes.mobileCellItemValue
												}
											>
												{row.original.place}
											</div>
										</React.Fragment>
									)}
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0016')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.cost}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0017')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.status}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0018')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getCancel(row)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0020')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getApproverId1(row)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0021')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getApproverId2(row)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('ApprovalsChange_0022')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getApproverId4(row)}
									</div>
								</div>
							</Paper>
						</>
					);
				},
				minWidth: 140,
				required: true,
			},
		];
	}

	protected getApproverId1(row: RowRenderProps) {
		if (row.original.needApprove1 !== 1) {
			return i18next.t('ApprovalsChange_0019');
		}
		const value =
			row.original.approverId1 == null ? '' : row.original.approverId1;
		return (
			<Select
				id="approverId1"
				input={<Input name="approverId1" />}
				autoWidth={true}
				onChange={this.onChangeApprover}
				value={
					this.state.approverId1 == null
						? value
						: this.state.approverId1
				}
				displayEmpty={true}
				classes={{
					selectMenu: this.props.classes.whiteSpace,
				}}
			>
				{row.original.approverList1.map(
					(approver: any, i: number): JSX.Element => (
						<MenuItem
							key={i}
							value={approver.id}
							data-classId={row.original.classId}
							className={this.props.classes.whiteSpaceMenuItem}
						>
							{i18next.t(approver.name, {
								ns: 'force',
							})}
						</MenuItem>
					)
				)}
			</Select>
		);
	}
	protected getApproverId2(row: RowRenderProps) {
		if (row.original.needApprove2 !== 1) {
			return i18next.t('ApprovalsChange_0019');
		}
		const value =
			row.original.approverId2 == null ? '' : row.original.approverId2;
		return (
			<Select
				id="approverId2"
				input={<Input name="approverId2" />}
				autoWidth={true}
				onChange={this.onChangeApprover}
				value={
					this.state.approverId1 == null
						? value
						: this.state.approverId2
				}
				displayEmpty={true}
				classes={{
					selectMenu: this.props.classes.whiteSpace,
				}}
			>
				{row.original.approverList2.map(
					(approver: any, i: number): JSX.Element => (
						<MenuItem
							key={i}
							value={approver.id}
							data-classId={row.original.classId}
							className={this.props.classes.whiteSpaceMenuItem}
						>
							{i18next.t(approver.name, {
								ns: 'force',
							})}
						</MenuItem>
					)
				)}
			</Select>
		);
	}
	protected getApproverId4(row: RowRenderProps) {
		if (row.original.needApprove4 !== 1) {
			return i18next.t('ApprovalsChange_0019');
		}
		const value =
			row.original.approverId4 == null ? '' : row.original.approverId4;
		return (
			<Select
				id="approverId4"
				input={<Input name="approverId4" />}
				autoWidth={true}
				onChange={this.onChangeApprover}
				value={
					this.state.approverId1 == null
						? value
						: this.state.approverId4
				}
				displayEmpty={true}
				classes={{
					selectMenu: this.props.classes.whiteSpace,
				}}
			>
				{row.original.approverList4.map(
					(approver: any, i: number): JSX.Element => (
						<MenuItem
							key={i}
							value={approver.id}
							data-classId={row.original.classId}
							className={this.props.classes.whiteSpaceMenuItem}
						>
							{i18next.t(approver.name, {
								ns: 'force',
							})}
						</MenuItem>
					)
				)}
			</Select>
		);
	}
	protected getCancel(row: RowRenderProps) {
		const { classes } = this.props;
		if (row.original.cancel === null) {
			return '---';
		}
		return (
			<Checkbox
				className={classes.checkbox}
				id="cancel"
				color="primary"
				data-index={row.index}
				onClick={this.onClickCancel}
				checked={!!row.original.cancel}
			/>
		);
	}
	protected getPeriod(row: RowRenderProps) {
		const careerType = row.original.careerType;
		const careerTypeId = row.original.careerTypeId;
		const classId = row.original.classId;
		const endDateByYear = row.original.endDateByYear;
		const endDateByDay = row.original.endDateByDay;
		let period = row.original.period;
		if (period && period.indexOf('～') !== -1) {
			period = period.replace(
				'～',
				i18next.t('～', {
					ns: 'force',
				})
			);
		}
		if (
			careerType === 0 &&
			careerTypeId === 1 &&
			classId === 'CL000000' &&
			endDateByYear !== null
		) {
			return i18next.t('ApprovalsChange_0023', {
				endDateByYear,
			});
		} else if (
			careerType === 0 &&
			careerTypeId === 1 &&
			classId === 'CL000000' &&
			endDateByDay !== null
		) {
			return i18next.t('ApprovalsChange_0024', {
				endDateByDay,
			});
		} else {
			return period;
		}
	}
	/**
	 * 選択カラム取得
	 */
	protected getSelectedColumns() {
		let columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		if (this.props.location.state.careerTypeID !== '2') {
			columns = columns.filter((column: any) => {
				return column.accessor !== 'place';
			});
		}
		return columns;
	}

	protected getSelectedMobileColumns() {
		const columns: any[] = Object.assign([], this.getAllMobileColumns());

		columns.map((column: any) => {
			column.show = true;
		});

		return columns;
	}

	/**
	 * カラム選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		let allColumns = this.getAllColumns();
		const checkboxList: any[] = [];

		if (this.props.location.state.careerTypeID !== '2') {
			allColumns = allColumns.filter((column: any) => {
				return column.accessor !== 'place';
			});
		}
		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="select-column-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 表示カラム選択ボタン
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 表示カラム選択メニュークローズ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * 表示カラム変更処理
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}

		this.props.setApprovalsSelectedColumns(newSelectedColumns);
	};

	protected closeDialog(event: React.MouseEvent<HTMLElement>) {
		this.props.openApprovals(false);
	}

	protected onClickCancel(event: React.MouseEvent<HTMLElement>) {
		const newApprovals = Object.assign([], this.props.data);
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			newApprovals[index].cancel = !newApprovals[index].cancel;
			this.props.setApprovals(newApprovals);
		}
	}

	protected onChangeApprover(event: React.ChangeEvent<HTMLSelectElement>) {
		const newApprovals = JSON.parse(JSON.stringify(this.props.data));
		const { name, value } = event.target;
		const classIdTemp = event.currentTarget.getAttribute('data-classId');
		const careerIdTemp = this.props.location.state.careerID;
		const approverId1 = this.props.location.state.approverId1;
		const approverId2 = this.props.location.state.approverId2;
		const approverId4 = this.props.location.state.approverId4;
		if (name && name !== '' && classIdTemp && classIdTemp !== '') {
			// tslint:disable-next-line: prefer-for-of
			for (let index = 0; index < newApprovals.length; index++) {
				if (newApprovals[index]['careerId'] === careerIdTemp) {
					if (this.state.approverId1 !== null) {
						newApprovals[index]['approverId1'] = approverId1;
					}
					if (this.state.approverId2 !== null) {
						newApprovals[index]['approverId2'] = approverId2;
					}
					if (this.state.approverId4 !== null) {
						newApprovals[index]['approverId4'] = approverId4;
					}
				}
				if (newApprovals[index]['classId'] === classIdTemp) {
					newApprovals[index][name] = value;
					this.props.setApprovals(newApprovals);
				}
			}
			this.setState({
				approverId1: null,
				approverId2: null,
				approverId4: null,
			});
		}
	}

	protected onChangeReason(event: React.ChangeEvent<HTMLInputElement>) {
		this.setState({ reason: event.target.value });
	}

	protected applyCareers() {
		const newApprovals = JSON.parse(JSON.stringify(this.props.data));
		const approverId1 = this.state.approverId1;
		const approverId2 = this.state.approverId2;
		const approverId4 = this.state.approverId4;
		// tslint:disable-next-line: prefer-for-of
		for (let index = 0; index < newApprovals.length; index++) {
			if (newApprovals[index]['classId'] === this.state.classId) {
				if (this.state.approverId1 !== null) {
					newApprovals[index]['approverId1'] = approverId1;
				}
				if (this.state.approverId2 !== null) {
					newApprovals[index]['approverId2'] = approverId2;
				}
				if (this.state.approverId4 !== null) {
					newApprovals[index]['approverId4'] = approverId4;
				}
				this.props.setApprovals(newApprovals);
			}
		}

		const params = {
			caller: this.props.location.state.caller,
			careerId: this.state.careerID,
			classId: this.state.classId,
			reason: this.state.reason,
		};
		this.props.openApprovalConfirm(false);
		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
		to = to.replace(
			/\/:career_id/,
			`/${this.props.location.state.careerID}`
		);
		to = to.replace(/\/:class_id/, `/${this.props.location.state.classId}`);
		this.props.pushHistoryState(to, params);
	}

	private getParams(): IApplyCareersParam {
		const { data } = this.props;
		const selectable = data.filter(
			item => item.classId === this.state.classId
		);
		const { reason } = this.state;

		const stayMealData: IApprovalStayMealData[] = [];
		const tempStayMealList = JSON.parse(
			JSON.stringify(this.props.approvalStayMealList)
		);
		// tslint:disable-next-line:prefer-for-of
		for (let xindex = 0; xindex < tempStayMealList.length; xindex++) {
			if (
				tempStayMealList[xindex].careerID === this.state.careerID &&
				tempStayMealList[xindex].classID === this.state.classId
			) {
				stayMealData.push(tempStayMealList[xindex]);
			}
		}

		let careerType = 0;
		const applies: IApply[] = selectable.map(
			(approval: IApprovalItem): IApply => {
				careerType = approval.careerType;
				return {
					approverId1: approval.approverId1,
					approverId2: approval.approverId2,
					approverId4: approval.approverId4,
					cancelWaitFlg: !!approval.cancel,
					careerId: approval.careerId,
					classId: approval.classId,
					stayMealData,
				};
			}
		);

		return {
			applies,
			careerType,
			reason,
		};
	}
}

const mapStateToProps = (state: IRootState) => ({
	approvalStayMealList: state.search.approvalStayMealList,
	canApproval: state.search.canApproval,
	changeApplicationData: state.imstat.changeApplication.data,
	data: state.search.approvals.data,
	isOpenApprovalConfirm: state.search.isOpenApprovalConfirm,
	isOpenCanApproval: state.search.isOpenCanApproval,
	selectedColumns: state.search.approvals.selectedColumns,
	selectedColumnsForStayMeal:
		state.search.approvals.selectedColumnsForStayMeal,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	applyCareers: (token: string, arg: IApplyCareersParam) => {
		const s = ScenarioFactory.createApplyCareers(dispatch, token);
		s.run(arg);
	},
	closeCanApproval: () =>
		dispatch(
			setCanApproval({
				data: { messageId: '', replacementStringList: [] },
				isOpenCanApproval: false,
			})
		),
	fetchCanApproval: (token: string, arg: IApplyCareersParam) => {
		const s = ScenarioFactory.createFetchCanApproval(dispatch, token);
		s.run(arg);
	},
	openApprovalConfirm: (open: boolean) =>
		dispatch(openApprovalConfirm({ open })),
	openApprovals: (isOpenApprovals: boolean) =>
		dispatch(openApprovals({ isOpenApprovals })),
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setApprovals: (data: IApprovalItem[]) => dispatch(setApprovals({ data })),
	setApprovalsSelectedColumns: (selectedColumns: number[]) =>
		dispatch(setApprovalsSelectedColumns({ selectedColumns })),
	setApprovalsSelectedColumnsForStayMeal: (selectedColumns: number[]) =>
		dispatch(setApprovalsSelectedColumnsForStayMeal({ selectedColumns })),
});

export interface IApprovalsChangeProps
	extends RouteComponentProps<{}, StaticContext, IRouteState> {
	caller: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IApprovalsChangeProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ApprovalsChange);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/ApprovalsChange.tsx